<template>
    <div>
        <confirm ref="confirm"></confirm>

        <!-- Loading Overlay for Bulk Delete -->
        <v-overlay :value="bulkDeleteLoading" z-index="9999">
            <v-card color="white" class="pa-6" elevation="10">
                <v-card-title class="justify-center">
                    <v-icon large color="primary" class="mr-2">mdi-delete-sweep</v-icon>
                    {{ $t('deleting items') }}
                </v-card-title>
                <v-card-text class="text-center">
                    <v-progress-circular
                        :size="70"
                        :width="7"
                        color="primary"
                        indeterminate
                        class="mb-4"
                    ></v-progress-circular>
                    <div class="text-h6">{{ bulkDeleteProgress }}</div>
                    <div class="mt-2">{{ bulkDeleteStatus }}</div>
                </v-card-text>
            </v-card>
        </v-overlay>

                <v-data-table
                    :headers="filteredHeader"
                    :items="result"
                    :items-per-page=10
                    :no-data-text="$t('no records found')"
                    :no-results-text="$t('no records found')"
                    :header-props="{'sort-by-text':$t('sort by')}"
                    :loading-text="$t('loading')"
                    :options.sync="options"
                    :page.sync="page"
                    :server-items-length="totalRows"
                    :sort-by="sortBy"
                    :sort-desc="sortDesc"
                    :must-sort="true"
                    :loading="loading"
                    show-select
                    v-model="selected"
                    @dblclick:row="rowDblClicked"
                    @click:row="rowClicked"
                    :item-class="computeClass"                                        
                    :hide-default-footer="true"
                    item-key="id"
                >
                    <template v-slot:header.actions>
                        <v-menu bottom offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    color="#49a5ac"
                                    fab
                                    x-small       
                                    outlined                             
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon>mdi-menu</v-icon>
                                </v-btn>                                                                                                
                            </template>                
                            <v-list dense rounded>
                                <v-list-item v-if="!hideNewAndEdit" @click=addNew()><v-list-item-icon><v-icon dense>mdi-plus-circle-outline</v-icon></v-list-item-icon><v-list-item-title>{{$t("new")}}</v-list-item-title></v-list-item>
                                <v-list-item @click=refreshList()><v-list-item-icon><v-icon dense>mdi-refresh</v-icon></v-list-item-icon><v-list-item-title>{{$t("refresh")}}</v-list-item-title></v-list-item>
                                <v-list-item v-if="!hideExport" @click=exportAll()><v-list-item-icon><v-icon dense>mdi-file-delimited-outline</v-icon></v-list-item-icon><v-list-item-title>{{$t("export all")}}</v-list-item-title></v-list-item>
                                <v-list-item v-if="!hideExport" @click=exportPage()><v-list-item-icon><v-icon dense>mdi-file-delimited-outline</v-icon></v-list-item-icon><v-list-item-title>{{$t("export page")}}</v-list-item-title></v-list-item>
                                <v-list-item v-if="!hideDelete && selected.length > 0" @click="bulkDelete()"><v-list-item-icon><v-icon dense>mdi-delete-outline</v-icon></v-list-item-icon><v-list-item-title>{{ $t('delete selected') }} ({{ selected.length }})</v-list-item-title></v-list-item>
                            </v-list>
                            </v-menu>
                    </template>

                    <template v-slot:item.actions="{ item }">
                        <v-icon :title="$t('edit')" v-if="!hideNewAndEdit && !showDownload" dense class="mr-2" @click="editItem(item)">mdi-pencil-outline</v-icon>
                        <v-icon :title="$t('download')" v-if="showDownload" dense class="mr-2" @click="editItem(item)">mdi-file-download-outline</v-icon>
                        <v-icon :title="$t('delete')" v-if="!hideDelete" dense class="mr-2" @click="deleteItem(item)">mdi-delete-outline</v-icon>
                    </template>
                    <template v-slot:item.lastlogin="{ item }">
                        {{item.lastlogin == null ? '' : new Date(item.lastlogin).toLocaleString("de-DE")}}
                    </template>
                    <template v-slot:item.loggedin="{ item }">
                        {{item.loggedin == null ? '' : new Date(item.loggedin).toLocaleString("de-DE")}}
                    </template>
                    <template v-slot:item.loggedout="{ item }">
                        {{item.loggedout == null ? '' : new Date(item.loggedout).toLocaleString("de-DE")}}
                    </template>
                    <template v-slot:item.tokenrefreshedat="{ item }">
                        {{item.tokenrefreshedat == null ? '' : new Date(item.tokenrefreshedat).toLocaleString("de-DE")}}
                    </template>
                    <template v-slot:item.created="{ item }">
                        {{new Date(item.created).toLocaleString("de-DE")}}
                    </template>
                    <template v-slot:item.updated="{ item }">
                        {{new Date(item.updated).toLocaleString("de-DE")}}
                    </template>
                    <template v-slot:item.starttimescraper="{ item }">
                        {{item.starttimescraper == null ? '' : new Date(item.starttimescraper).toLocaleString("de-DE")}}
                    </template>
                    <template v-slot:item.endtimescraper="{ item }">
                        {{item.endtimescraper == null ? '' : new Date(item.endtimescraper).toLocaleString("de-DE")}}
                    </template>
                    <template v-slot:item.starttimewrite="{ item }">
                        {{item.starttimewrite == null ? '' : new Date(item.starttimewrite).toLocaleString("de-DE")}}
                    </template>
                    <template v-slot:item.endtimewrite="{ item }">
                        {{item.endtimewrite == null ? '' : new Date(item.endtimewrite).toLocaleString("de-DE")}}
                    </template>
                    <template v-slot:item.status="{ item }">
                        <v-icon v-if="item.status && item.status == 'finished'" color=green>mdi-check-bold</v-icon> {{ item.status }}
                    </template>
                    <template v-slot:item.manually="{ item }">
                        <v-icon v-if="item.manually" color=green>mdi-check-bold</v-icon>
                        <span v-else>{{item.manually}}</span>
                    </template>
                    <template v-slot:item.isadmin="{ item }">
                        <v-icon v-if="item.isadmin" color=green>mdi-check-bold</v-icon>
                    </template>
                    <template v-slot:item.isactive="{ item }">
                        <v-icon v-if="item.isactive" color=green>mdi-check-bold</v-icon>
                    </template>
                    <template v-slot:item.processed="{ item }">
                        <v-icon v-if="item.processed" color=green>mdi-check-bold</v-icon>
                    </template>
                    <template v-slot:item.relevant="{ item }">
                        <v-icon v-if="item.relevant" color=green>mdi-check-bold</v-icon>
                    </template>
                    <template v-slot:item.zalando="{ item }">
                        <v-icon v-if="item.zalando" color=green>mdi-check-bold</v-icon>
                    </template>
                    <template v-slot:item.douglas="{ item }">
                        <v-icon v-if="item.douglas" color=green>mdi-check-bold</v-icon>
                    </template>
                    <template v-slot:item.defektmonitor="{ item }">
                        <v-icon v-if="item.defektmonitor" color=green>mdi-check-bold</v-icon>
                    </template>
                    <template v-slot:item.slide="{ item }">
                        <v-icon v-if="item.slide" color=green>mdi-check-bold</v-icon>
                    </template>
                    <template v-slot:item.startdate="{ item }">
                        {{item.startdate == null ? '' : new Date(item.startdate).toLocaleDateString("de-DE")}}
                    </template>
                    <template v-slot:item.enddate="{ item }">
                        {{item.enddate == null ? '' : new Date(item.enddate).toLocaleDateString("de-DE")}}
                    </template>
                    <template v-slot:item.src="{ item }">
                        <img height=50 v-bind:src="generateDownloadUrl(item)">
                    </template>
                    <template v-slot:item.local_file="{ item }">
                        <img height=50 v-bind:src="generateDownloadCategoryAdUrl(item)">
                    </template>
                    <template v-slot:item.country="{ item }">
                        {{getCountry(item.country)}}
                    </template>
                    <template v-slot:item.picavailable="{ item }">
                        <v-icon v-if="item.picavailable" color=green>mdi-check-bold</v-icon>
                    </template>
                    <template v-slot:item.vidavailable="{ item }">
                        <v-icon v-if="item.vidavailable" color=green>mdi-check-bold</v-icon>                        
                    </template>
                    <template v-slot:item.pdfavailable="{ item }">
                        <v-icon v-if="item.pdfavailable" color=green>mdi-check-bold</v-icon>
                    </template>
                    <template v-slot:item.recommended="{ item }">
                        <v-icon v-if="item.recommended" color=green>mdi-check-bold</v-icon>
                    </template>
                    <template v-slot:item.available="{ item }">
                        <v-icon v-if="item.available" color=green>mdi-check-bold</v-icon>
                    </template>
                    <template v-slot:item.prioproduct="{ item }">
                        <v-icon v-if="item.prioproduct" color=green>mdi-check-bold</v-icon>
                    </template>
                    <template v-slot:item.launch="{ item }">
                        <v-icon v-if="item.launch" color=green>mdi-check-bold</v-icon>
                    </template>
                    <template v-slot:item.url="{ item }">
                        <a :href="item.url" target="_new">{{item.url}}</a>
                    </template>
                    <template v-slot:item.picname="{ item }">
                        <img height="100" :src="generatePicUrl(item)">
                    </template>
                    <template v-slot:item.prev="{ item }">
                        <span v-bind:class=generateScraperClass(item)>{{item.prev}}</span>
                    </template>
                    <template v-slot:item.lastfound="{ item }">
                        <v-icon v-if="Math.floor(new Date() - new Date(item.lastfound)) / 86400000 <= 7" color=green>mdi-check-bold</v-icon>
                        <v-icon v-else-if="Math.floor(new Date() - new Date(item.lastfound)) / 86400000 <= 14" color=yellow>mdi-check-bold</v-icon>
                        <v-icon v-else color=red>mdi-alert</v-icon>
                        {{new Date(item.lastfound).toLocaleDateString("de-DE")}}
                    </template>
                    <template v-slot:item.hastext="{ item }">
                        <v-icon v-if="item.hastext" color=green>mdi-check-bold</v-icon>
                    </template>
                </v-data-table>
    </div>
</template>

<script>

import Api from "@/Api";
import Confirm from "@/components/Confirm";

export default
{
    components: {
        Confirm
    },

    props: ["table", "refresh", "hideNewAndEdit", "hideDelete", "hideExport", "showDownload", "initialSortBy", "initialSortDesc", "parentId", "label", "type"],

    computed:
    {
        filteredHeader()
        {
            let h;
            if (this.table == "customers" || this.table == "scraper" || this.table == "pharmacies")
                h = this.header;
            else
                h = this.header.filter(h => h.value !== "id");
            
            for (let item of h)
            {
                item.text = this.$t(item.text);
            }
            return h;
        }
    },

    data: function ()
    {
        return {
            result: [],
            header: [],
            search: "",
            options: {},
            totalRows: 0,
            searchterm: "",
            pageSize: 10,
            page: 1,
            sortBy: this.initialSortBy,
            sortDesc: this.initialSortDesc,
            loading: false,
            selectedId: null,
            selected: [],

            // Bulk delete loading states
            bulkDeleteLoading: false,
            bulkDeleteProgress: "",
            bulkDeleteStatus: ""
        }
    },

    watch:
    {
        options:
        {
            handler (options)
            {
                this.sortBy = options.sortBy[0];
                this.sortDesc = options.sortDesc[0];
                this.pageSize = options.itemsPerPage;
                this.getData(options.page, options.itemsPerPage, this.sortBy, this.sortDesc, this.parentId);
            },
            deep: true,
        },
        refresh: function()
        {
            this.getData(1, this.pageSize, this.sortBy, this.sortDesc, this.parentId);
            this.page = 1;
        },
        parentId: function()
        {
            this.getData(1, this.pageSize, this.sortBy, this.sortDesc, this.parentId);
            this.page = 1;
        }
    },

    methods:
    {
        computeClass: function(item)
        {
            if (this.selectedId != null && item.id == this.selectedId)
                return ("blue-grey lighten-5");
        },
        generateScraperClass: function(item)
        {                   
            if (item.status !== "finished")
            {
                return ""
            }
            let cnt = parseInt(item.cnt);
            let prev = parseInt(item.prev);
            
            if (cnt == 0 && prev > 0)
            {
                return "scraper-alert";
            }
            else            
            {
                return prev > 0 && cnt > 0 && prev*100/cnt > 105 ? "scraper-alert": "";
            }
        },
        generatePicUrl: function(item)
        {
            return Api.generatePicUrl(item.picname)
        },
        generateDownloadUrl: function(item)
        {
            return Api.generateDownloadAdUrl(item.name, item.src)
        },
        generateDownloadCategoryAdUrl: function(item)
        {
            return Api.generateDownloadCategoryAdUrl(item.name, item.local_file)
        },
        refreshList: function()
        {
            this.getData(1, this.pageSize, this.sortBy, this.sortDesc, this.parentId);
            this.page = 1;
        },
        addNew()
        {
            this.$emit("childMessage", {cmd: "newRecord", header: this.header, type: this.type})
        },
        rowDblClicked(ev, data)
        {
            this.editItem(data.item)
        },
        rowClicked(ev, data)
        {
            this.selectedId = data.item.id;
            this.$emit("childMessage", {cmd: "recordSelected", header: this.header, item: data.item, type: this.type})
        },
        editItem(item)
        {
            this.$emit("childMessage", {cmd: "updRecord", header: this.header, item: item, type: this.type})
        },
        deleteItem(item)
        {
            this.$refs.confirm.open('Wirklich löschen?').then((confirm) =>
            {
                if (confirm)
                    this.$emit("childMessage", {cmd: "delRecord", item: item, type: this.type})
            });
        },
        async bulkDelete() {
            const itemsToDelete = [...this.selected];
            const totalItems = itemsToDelete.length;

            if (totalItems === 0) {
                return;
            }

            // Ask for confirmation
            const confirmMessage = this.$t('delete selected items confirmation') ||
                                 `Wirklich ${totalItems} Einträge löschen?`;
            const confirmed = await this.$refs.confirm.open(confirmMessage);

            if (!confirmed) {
                return;
            }

            // Start bulk delete process
            this.bulkDeleteLoading = true;
            this.bulkDeleteProgress = `0 / ${totalItems}`;
            this.bulkDeleteStatus = this.$t('preparing deletion') || 'Vorbereitung...';

            let successCount = 0;
            let errorCount = 0;
            const errors = [];

            // Loop through selected items and delete one by one
            for (let i = 0; i < itemsToDelete.length; i++) {
                const item = itemsToDelete[i];
                this.bulkDeleteProgress = `${i + 1} / ${totalItems}`;
                this.bulkDeleteStatus = this.$t('deleting item') || `Lösche Eintrag ${item.id}...`;

                try {
                    // Call the backend delete endpoint
                    const result = await Api.deleteRecord(this.table, item.id);

                    if (result.status === 200) {
                        successCount++;
                    } else {
                        errorCount++;
                        errors.push({ id: item.id, error: this.$t('deletion failed') || 'Löschen fehlgeschlagen' });
                    }
                } catch (e) {
                    errorCount++;
                    const errorMsg = (e.response && e.response.data && e.response.data.message) || e.message || this.$t('unknown error');
                    errors.push({ id: item.id, error: errorMsg });
                    console.error(`Error deleting item ${item.id}:`, e);
                }
            }

            // Finish deletion process
            this.bulkDeleteLoading = false;
            this.selected = [];

            // Show result message
            let message = `${this.$t('deletion complete') || 'Löschen abgeschlossen'}\n`;
            message += `${this.$t('successful') || 'Erfolgreich'}: ${successCount}\n`;

            if (errorCount > 0) {
                message += `${this.$t('failed') || 'Fehlgeschlagen'}: ${errorCount}\n\n`;
                if (errors.length > 0) {
                    message += this.$t('errors') || 'Fehler' + ':\n';
                    errors.slice(0, 5).forEach(err => {
                        message += `ID ${err.id}: ${err.error}\n`;
                    });
                    if (errors.length > 5) {
                        message += `... ${this.$t('and') || 'und'} ${errors.length - 5} ${this.$t('more') || 'weitere'}`;
                    }
                }
            }

            alert(message);

            // Refresh the list
            this.refreshList();
        },
        filterData()
        {
            this.getData(1, this.pageSize, this.sortBy, this.sortDesc, this.parentId);
            this.page = 1;
        },
        getCountry(code)
        {            
            return this.$store.state.countries[code];
        },
        getData(page, pageSize, sortBy, sortDesc, parentId)
        {
            this.loading = true;
            this.result=[]
            Api.getRecords(this.table, page, pageSize, this.search, sortBy, sortDesc, parentId).then(response =>
            {
                this.result = response.data.result.map(row => {
                    const newRow = { ...row };
                    for (const key of Object.keys(newRow)) {
                        if (newRow[key] === 'true' || newRow[key] === true) newRow[key] = true;
                        else if (newRow[key] === 'false' || newRow[key] === false) newRow[key] = null;
                    }
                    return newRow;
                });
                this.header = response.data.header;
                this.header.unshift ({ text: '', width: 90, value: 'actions', sortable: false })
                this.totalRows = response.data.total;
                this.loading = false;
                this.$emit("childMessage", {cmd: "searchExecuted", type: this.type});
                this.selectedId = null;
                this.selected = [];
            })
            .catch((e) =>
            {                
            });
        },
        exportAll()
        {            
            const self = this;
            Api.exportRecords(this.table, this.search, this.sortBy, this.sortDesc, this.parentId).then(response =>
            {
                const ticket = response.data.ticket;
                Api.exportTicket(ticket);                
            })
            .catch((e) =>
            {
                let txt = self.$t("export not possible");
                alert(txt);
            });
        },
        exportPage()
        {            
            const self = this;
            Api.exportRecords(this.table, this.search, this.sortBy, this.sortDesc, this.parentId, this.page, this.pageSize).then(response =>
            {
                const ticket = response.data.ticket;
                Api.exportTicket(ticket);
            })
            .catch((e) =>
            {
                let txt = self.$t("export not possible");
                alert(txt);
            });            
        }
    },
}
</script>

<style>
    tbody tr:nth-of-type(odd)
    {
        background-color: #e3eeee;
    }

    .hidden
    {
        visibility: hidden;
    }

    th
    {
        position: sticky;
        top: 3rem;
        background: lightgray;
        z-index: 6;
    }

    .v-data-table .v-data-table__wrapper
    {
        overflow: unset;
    }

    .scraper-alert
    {
        vertical-align:middle;
    }

    .scraper-alert::after
    {
        width:100%;
        content: "\00A0\00A0\00A0\00A0\00A0\26A0";        
        font-size:200%;
        color:red;
    }
</style>
